import { render } from "./CategoryColumnsMiddleArticle.vue?vue&type=template&id=5e6962ff"
import script from "./CategoryColumnsMiddleArticle.vue?vue&type=script&lang=js"
export * from "./CategoryColumnsMiddleArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__